import type { ObjectId } from "@bbj-types/utils";
import { StackGrid, stackGridClasses } from "@data-display/layout/StackGrid";
import { DateInputForm, TextFieldForm } from "@inputs/hook-form";
import { Divider } from "@mui/material";
import type { Control, UseFormSetValue } from "react-hook-form";
import type { IResolverCreateCandidateChallenge } from "../logics/types";
import { AutocompleteChallenges } from "./inputs/challenges";
import { AutocompleteObjectives } from "./inputs/objectives";
import type { IFormCreateCandidateChallenge } from "./logics";

export interface IFormCreateCandidateChallengeProps {
  control: Control<IFormCreateCandidateChallenge, void, IResolverCreateCandidateChallenge>;
  setValue: UseFormSetValue<IFormCreateCandidateChallenge>;
  excludeChallenges?: ObjectId[];
}

export const FormCreateCandidateChallenge = ({
  control,
  setValue,
  excludeChallenges,
}: IFormCreateCandidateChallengeProps) => {
  return (
    <StackGrid direction="row" perLine={{ tablet: 2 }} gap={2} strict>
      <AutocompleteChallenges control={control} excludeChallenges={excludeChallenges} />
      <TextFieldForm
        control={control}
        name="description"
        maxLength={300}
        label="Description"
        multiline
        rows={2}
        size="small"
        fullWidth
        className={stackGridClasses.fullWidth}
      />
      <Divider orientation="horizontal" flexItem sx={{ maxWidth: "100%", flexBasis: "100%" }} />
      <AutocompleteObjectives control={control} setValue={setValue} />
      <DateInputForm
        control={control}
        name="objectiveEndDate"
        label="Date butoir"
        TextFieldProps={{ size: "small", fullWidth: true }}
        disablePast
      />
      <TextFieldForm
        control={control}
        name="objectiveTitle"
        maxLength={80}
        label="Titre"
        size="small"
        fullWidth
        className={stackGridClasses.fullWidth}
      />
    </StackGrid>
  );
};
